import { createInstance, type i18n as I18n } from 'i18next';
import { initReactI18next } from 'react-i18next';

import enUS from '../locales/en-US/translation.json';

const i18n: I18n = createInstance();
i18n.use(initReactI18next).init({
  // hard coding tests to just english for now
  lng: 'en-US',
  fallbackLng: 'en-US',
  resources: {
    'en-US': {
      translation: enUS,
    },
    en: {
      translation: enUS,
    },
  },
});

export default i18n;
